import { render, staticRenderFns } from "./contactsInputMore.vue?vue&type=template&id=063fce3a&scoped=true&"
import script from "./contactsInputMore.vue?vue&type=script&lang=ts&"
export * from "./contactsInputMore.vue?vue&type=script&lang=ts&"
import style0 from "./contactsInputMore.vue?vue&type=style&index=0&id=063fce3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063fce3a",
  null
  
)

export default component.exports